import { waLink } from '../lib/whatsapp';

const NUMERO = '71991588139';
const MENSAGEM = 'Oi! Tudo bem? Estou usando o sistema Coala e surgiu uma dúvida — pode me ajudar? 🐨';

export function FaleConoscoButton() {
  return (
    <a
      href={waLink(NUMERO, MENSAGEM)}
      target="_blank"
      rel="noreferrer"
      title="Fale conosco"
      aria-label="Fale conosco pelo WhatsApp"
      style={{
        position: 'fixed', bottom: 78, right: 14, zIndex: 30,
        width: 40, height: 40, borderRadius: '50%',
        background: 'var(--paper)', border: '1.5px solid var(--line-strong)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 18, textDecoration: 'none', opacity: 0.85, boxShadow: 'var(--shadow)',
      }}
    >
      💬
    </a>
  );
}
